import React from 'react';
import { salesPageData, isPlaceholder } from '../data/salesPageData';
import { CTAButton } from './ui/CTAButton';

/**
 * Sección de UPSELL.
 * Permanece oculta hasta que `salesPageData.upsell.enabled` sea true y se carguen
 * el nombre, mockup, precio, descripción y link de checkout reales.
 */
export function UpsellSection() {
  const {
    upsell
  } = salesPageData;
  const ready = upsell.enabled && !isPlaceholder(upsell.name) && !isPlaceholder(upsell.price) && !isPlaceholder(upsell.checkoutUrl);
  if (!ready) return null;
  return <section className="border-t border-[#EFEDE8]/10 bg-[#111111]" aria-labelledby="upsell-title" data-id="element-403" data-mp="1hnmfkzn9x9p7">
      <div className="mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-404" data-mp="1dnuch2gnfvr8">
        <div className="mx-auto grid max-w-4xl items-center gap-8 rounded-2xl border border-[#D89A3D]/30 bg-[#181512] p-7 sm:p-10 lg:grid-cols-2" data-id="element-405" data-mp="18pj1upij5h7y">
          {upsell.image && <img src={upsell.image} alt={`Mockup de ${upsell.name}`} className="w-full rounded-xl drop-shadow-[0_24px_50px_rgba(0,0,0,0.6)]" loading="lazy" data-id="element-406" data-mp="332s4bxcns2gp" />}
          <div data-id="element-407" data-mp="1qlau10xsj5qx">
            <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#FF7A00]" data-id="element-408" data-mp="1qoq8c1jn4ara">
              Sumá a tu Bóveda
            </p>
            <h2 id="upsell-title" className="mt-3 font-display text-2xl font-black uppercase leading-tight tracking-tight text-[#F8F3EA] sm:text-3xl" data-id="element-409" data-mp="1hmz6j7s80o2p">
              {upsell.name}
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-[#EFEDE8]/70" data-id="element-410" data-mp="2abo0mmuuzt4y">
              {upsell.description}
            </p>
            <p className="mt-5 font-numeric text-4xl font-bold text-[#FF7A00]" data-id="element-411" data-mp="2ebew33vbyxft">
              {upsell.price} {salesPageData.currency}
            </p>
            <div className="mt-6" data-id="element-412" data-mp="25jcx7a0wtp7n">
              <CTAButton href={upsell.checkoutUrl} external size="large" data-id="element-413" data-mp="25ibmj6nt34qg">
                Quiero sumarlo
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}